<template lang="pug">
v-row.align-center.text-center(v-if="!isKioskMode")
    v-col.flex-shrink-1.flex-grow-0
        v-btn(fab icon :disabled="!isBackButtonEnabled" :large="showLargeButton")
            v-icon(color="teal" @click="onPrevButtonClick") fas fa-chevron-circle-left
    v-col.flex-shrink-0.flex-grow-1.pa-0
        v-row.pt-3(no-gutters)
            v-col {{ weekLabel }}
            v-col {{ weekRange }}
    v-col.flex-shrink-1.flex-grow-0
        v-btn(fab icon :large="showLargeButton")
            v-icon(color="teal" @click="onNextButtonClick")  fas fa-chevron-circle-right
v-row.ma-0.align-start.text-start(v-else no-gutters)
  v-col.pa-0.pr-0(cols="1")
    v-btn.pr-4(fab icon :disabled="!isBackButtonEnabled" large)
      v-icon(color="teal" @click="onPrevButtonClick" large) fas fa-chevron-circle-left
  v-col.pa-0(cols="9")
    v-row.pt-4(no-gutters)
      v-col.text-h6.pa-0.text-start.pl-4(cols="6" xl="6" lg="6" md="6" sm="6") {{ weekLabel }}
      v-col.text-h6.pa-0.text-end.pr-0(cols="6" xl="6" lg="6" md="6" sm="6") {{ weekRange }}
    v-row.ma-0
      v-col.text-h6.pa-0.text-center(cols="5" xl="5" lg="5" md="5" sm="5") {{ dateYear }}
  v-col.pa-0.pl-0.pr-4(cols="2")
    v-btn(fab icon large)
      v-icon(color="teal" @click="onNextButtonClick" large)  fas fa-chevron-circle-right

</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment'
import {Component, Prop} from "vue-property-decorator";
import {GET_MODE} from "@/store/getter-types";

@Component({
  components: {}
})
export default class CalendarWeekSelector extends Vue {
  @Prop({type: String, required: true}) isoWeek!: string
  @Prop({type: Boolean, default: true}) allowNavigationToPast!: boolean
  @Prop({type: Date}) date!: Date

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get weekLabel (): string {
    const locale =localStorage.getItem('uiLanguageCodeApp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk'
    return `${moment(this.isoWeek).locale(locale).format('W')}. ${this.$t('orderPage.weekName')}`
  }

  get dateYear (): string {
    return moment(this.date).format('Y')
  }

  get weekRange (): string {
    const start = moment(this.isoWeek)
    const end = start.clone().add(1, 'week')

    return `${start.format('D.M')} - ${end.format('D.M')}`
  }

  get isBackButtonEnabled (): boolean {
    if (this.allowNavigationToPast) {
      return true
    } else {
      const currentWeekStart = moment().startOf('isoWeek')
      const previousWeekStart = moment(this.isoWeek).subtract(1, 'week').startOf('isoWeek')

      return !previousWeekStart.isBefore(currentWeekStart)
    }
  }

  get showLargeButton (): boolean {
    return !this.$vuetify.breakpoint.xs
  }

  onNextButtonClick (): void {
    this.$emit('update:isoWeek', moment(this.isoWeek).add(1, 'week').format('GGGG[W]WW'))
  }

  onPrevButtonClick (): void {
    this.$emit('update:isoWeek', moment(this.isoWeek).subtract(1, 'week').format('GGGG[W]WW'))
  }
}
</script>

<style lang="stylus" scoped>

</style>
